import React, { useEffect } from 'react';
const AngularMicrofrontend = () => {
  useEffect(() => {
    const location = window.location.href;
    let urlDev =
      location.includes('dev') || location.includes('localhost') ? '.dev' : '';

    const styleLink = document.createElement('link');
    styleLink.rel = 'stylesheet';
    styleLink.href = `https://cdn${urlDev}.digiconcrete.es/ehe/css/styles.css`;
    document.head.appendChild(styleLink);

    const runtimeScript = document.createElement('script');
    runtimeScript.src = `https://cdn${urlDev}.digiconcrete.es/ehe/js/runtime.js`;
    runtimeScript.async = true;

    const polyfillsScript = document.createElement('script');
    polyfillsScript.src = `https://cdn${urlDev}.digiconcrete.es/ehe/js/polyfills.js`;
    polyfillsScript.async = true;

    const scriptsScript = document.createElement('script');
    scriptsScript.src = `https://cdn${urlDev}.digiconcrete.es/ehe/js/scripts.js`;
    scriptsScript.async = true;

    const mainScript = document.createElement('script');
    mainScript.src = `https://cdn${urlDev}.digiconcrete.es/ehe/js/main.js`;
    mainScript.async = true;

    document.body.appendChild(runtimeScript);
    document.body.appendChild(polyfillsScript);
    document.body.appendChild(scriptsScript);
    document.body.appendChild(mainScript);

    return () => {
      window.location.href = window.location.origin + window.location.pathname;
      document.body.removeChild(runtimeScript);
      document.body.removeChild(polyfillsScript);
      document.body.removeChild(scriptsScript);
      document.body.removeChild(mainScript);
      document.head.removeChild(styleLink);
    };
  }, []);

  return (
    <div className="wrapper fullscreen">
      {/*eliminar el elemento padre del layout wrapper para que se vea bien  */}
      <div id="root">
        <app-root></app-root>
      </div>
    </div>
  );
};

export default AngularMicrofrontend;
